import React from "react";

import WComponent from "../../../common/WComponent";
import ToolsModal from "../kit/ToolsModal";
import ToolsSelect from "../kit/ToolsSelect";
import AddIndustryRow from "../kit/AddIndustryRow";

import PROVINCES from "../../../../constants/Provinces";

import "./classify-missing-fields-modal.css";

class ClassifyMissingFieldsModal extends WComponent {
	constructor(props) {
		super(props);

		this.state = {
			provinceDraft: "",
			industryDraft: "",
		};
	}

	onContinueClicked = () => {
		const { onSave } = this.props;
		const { provinceDraft, industryDraft } = this.state;

		onSave({ province: provinceDraft, industry: industryDraft.trim() });
	};

	onIndustryAdded = ({ industry, alreadyExisted }) => {
		const { onIndustriesChange, industries } = this.props;
		if (!alreadyExisted && onIndustriesChange) {
			onIndustriesChange([...(industries || []), industry]);
		}
		this.update({ industryDraft: industry.name });
	};

	renderFooter = () => {
		const { needsProvince, needsIndustry, onClose } = this.props;
		const { provinceDraft, industryDraft } = this.state;

		const canSave = (needsProvince ? !!provinceDraft : true) && (needsIndustry ? !!industryDraft.trim() : true);

		return (
			<>
				<span />
				<span className="tk-modal-actions">
					<button type="button" className="tk-button tk-button--secondary" onClick={onClose}>Cancel</button>
					<button type="button" className="tk-button tk-button--primary" onClick={this.onContinueClicked} disabled={!canSave}>Continue</button>
				</span>
			</>
		);
	};

	render() {
		const { needsProvince, needsIndustry, industries, onClose } = this.props;
		const { provinceDraft, industryDraft } = this.state;

		const industryChoices = (industries || []).map(i => ({ value: i.name, label: i.name }));
		const provinceChoices = PROVINCES.map(province => ({ value: province.name, label: province.name }));

		return (
			<ToolsModal open={true} onClose={onClose} title="A couple of details before classifying" width={480} footer={this.renderFooter()}>
				<p className="bk-missing__intro">We use these to pick the right tax codes and chart of accounts.</p>

				{needsProvince && (
					<div className="tk-form-field">
						<div className="tk-form-label">Province</div>
						<ToolsSelect
							value={provinceDraft}
							options={provinceChoices}
							onChange={selectedProvince => this.update({ provinceDraft: selectedProvince })}
							placeholder="Select a province…"
							searchable
							searchPlaceholder="Search provinces…"
						/>
					</div>
				)}

				{needsIndustry && (
					<div className="tk-form-field">
						<div className="tk-form-label">Industry</div>
						<ToolsSelect
							value={industryDraft}
							options={industryChoices}
							onChange={selectedIndustry => this.update({ industryDraft: selectedIndustry })}
							placeholder="Select an industry…"
							searchable
							searchPlaceholder="Search industries…"
						/>
						<AddIndustryRow onAdded={this.onIndustryAdded} />
					</div>
				)}
			</ToolsModal>
		);
	}
}

export default ClassifyMissingFieldsModal;
